export function readingTime(root, level) {
    const ignore = [];
    if (level > 0) {
        ignore.push({ name: 'class', value: 'block-hidden' });
        ignore.push({ name: 'class', value: 'text-hidden' });
    }
    for (let i = level - 1; i > 0; i -= 1) {
        ignore.push({
            name: 'data-level',
            value: i.toString(),
        });
    }
    const innerText = buildInnerText(root, ignore)
        .replace(/[\r\n]/g, ' ')
        .trim().replace(/\s\s+/g, ' ');
    return innerText / 1000;
}
function buildInnerText(el, ignoreAttrs) {
    if (el.nodeType === 1) {
        for (const attr of ignoreAttrs) {
            if (hasAttribute(el, attr.name, attr.value)) {
                return '';
            }
        }
    }
    if (el.hasChildNodes()) {
        return Array.from(el.childNodes).reduce((text, current) => `${text}${buildInnerText(current, ignoreAttrs)}`, '');
    }
    return (el.nodeType === 3) ? el.textContent : '';
}
function hasAttribute(node, name, value) {
    if (!node.hasAttribute(name)) {
        return false;
    }
    if (name === 'class') {
        return node.getAttribute(name).includes(value);
    }
    else {
        return node.getAttribute(name) === value;
    }
}
